import { ModuleWithProviders, NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from 'src/app/views/views.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { DonateComponent } from './donate/donate.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { GlobalCounselComponent } from './terms/global-counsel/global-counsel.component';
import { GlobalCounselService } from './terms/global-counsel/global-counsel.service';
import { PrivacyComponent } from './terms/privacy/privacy.component';
import { TermsOfUseComponent } from './terms/terms-of-use/terms-of-use.component';
import { TermsComponent } from './terms/terms/terms.component';

@NgModule({
  imports: [SharedModule, ViewsModule, QRCodeModule],
  declarations: [
    PrivacyComponent,
    TermsOfUseComponent,
    TermsComponent,
    GlobalCounselComponent,
    DonateComponent,
    QrcodeComponent,
    AboutUsComponent,
  ],
  exports: [
    PrivacyComponent,
    TermsOfUseComponent,
    TermsComponent,
    GlobalCounselComponent,
    DonateComponent,
    QrcodeComponent,
    AboutUsComponent,
  ],
  providers: [GlobalCounselService],
})
export class StaticModule {
  public static forRoot(): ModuleWithProviders<StaticModule> {
    return {
      ngModule: StaticModule,
      providers: [GlobalCounselService],
    };
  }
}
